import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { useLang } from "../lib/i18n";
import { useBusy } from "../components/common";
import { fmtDateTime } from "../lib/helpers";
import { AuthShell } from "./ForgotPassword";

export default function BlockDevice() {
  const { token } = useParams();
  const { t, lang } = useLang();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, run] = useBusy();
  useEffect(() => { api.get(`/security/block/${token}`).then((r) => setInfo(r.data)).catch((e) => setError(errMsg(e))); }, [token]);
  const block = () => run(async () => {
    try { await api.post(`/security/block/${token}`); setDone(true); } catch (e) { setError(errMsg(e)); }
  });
  return (
    <AuthShell testid="block-device-page">
      <h1 className="text-3xl font-extrabold text-slate-900 flex items-center gap-2"><ShieldAlert className="w-8 h-8 text-red-700" />{t("This wasn't me", "No fui yo")}</h1>
      {error && <p className="mt-4 p-4 rounded-xl bg-red-50 text-red-800" data-testid="block-device-error">{error}</p>}
      {done && (
        <p className="mt-4 p-4 rounded-xl bg-emerald-50 text-emerald-800" data-testid="block-device-done">
          {t("Done. The device is blocked, the account was signed out everywhere and a password-reset email was sent to the account.", "Listo. El dispositivo quedó bloqueado, se cerraron todas las sesiones y se envió un correo para restablecer la contraseña.")}
        </p>
      )}
      {info && !done && !error && (
        <div className="mt-4 grid gap-4" data-testid="block-device-info">
          <div className="rounded-xl border p-4 text-sm grid gap-1">
            <div><span className="text-slate-500">{t("Account", "Cuenta")}:</span> <b>{info.user_name}</b></div>
            <div><span className="text-slate-500">{t("Device", "Dispositivo")}:</span> <b>{info.device_name}</b></div>
            <div><span className="text-slate-500">IP:</span> {info.ip}</div>
            <div><span className="text-slate-500">{t("Signed in", "Entró")}:</span> {fmtDateTime(info.signed_in_at, lang)}</div>
          </div>
          <p className="text-slate-600">{t("This will block this device, sign the account out of ALL devices, and require a new password before anyone can sign in again.", "Esto bloqueará el dispositivo, cerrará la sesión en TODOS los dispositivos y exigirá una nueva contraseña antes de volver a entrar.")}</p>
          <button className="btn-primary h-14 text-base !bg-red-700" disabled={busy} onClick={block} data-testid="block-device-confirm-btn">{t("Block device and lock account", "Bloquear dispositivo y la cuenta")}</button>
        </div>
      )}
      <Link to="/login" className="mt-6 text-sm font-semibold text-[#D9531E]" data-testid="block-device-back-to-login">{t("Go to sign in", "Ir a iniciar sesión")}</Link>
    </AuthShell>
  );
}
